import React from "react";
import { userimg } from "../../constants";

const Sidebar = () => {
	return (
		<>
			{/* profile heading wrapper */}
			<div className="profile-heading-wrapper">
				<h2>My Profile</h2>
			</div>
			{/* profile heading wrapper */}
			<div className="sidebar-wrapper">
				<div className="user-details-wrapper">
					<div className="user-img-wrapper">
						<figure>
							<img src={userimg} className="img-fluid" alt="" />
						</figure>
						<div className="change-img-wrapper">
							<button>Change image</button>
						</div>
					</div>
					<div className="user-name-wrapper">
						<h4>John Doe</h4>
					</div>
				</div>
				<div className="navlink-wrapper">
					<ul>
						<li className="nav-item">
							<a href="/MyProfile" className="nav-link">
								Account
							</a>
						</li>
						<li className="nav-item">
							<a href="/Myorder" className="nav-link">
								My Order
							</a>
						</li>
						<li className="nav-item">
							<a href="/MyWishlist" className="nav-link">
								My Wishlist
							</a>
						</li>
						<li className="nav-item">
							<a href="/Security" className="nav-link">
								Security
							</a>
						</li>
						<li className="nav-item">
							<a href="/Payment" className="nav-link">
								Payment
							</a>
						</li>
						<li className="nav-item">
							<a href="/MyAddresses" className="nav-link">
								Address
							</a>
						</li>
						<li className="nav-item">
							<a href="/share" className="nav-link">
								Referral Code
							</a>
						</li>
						<li className="nav-item">
							<a href="/view-banner-ads" className="nav-link">
								Banner Ads
							</a>
						</li>
						<li className="nav-item">
							<a href="/return-request" className="nav-link">
								Return Request
							</a>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default Sidebar;
